export const QR_IMAGE_ACCEPT = 'image/png,image/jpeg';
export const QR_IMAGE_MAX_SIZE = 5 * 1024 * 1024;

export const qrImageError = (file: File): string | undefined => {
  if (!QR_IMAGE_ACCEPT.split(',').includes(file.type)) {
    return 'Загрузите изображение в формате PNG или JPG';
  }
  if (file.size > QR_IMAGE_MAX_SIZE) {
    return 'Размер изображения — не более 5 МБ';
  }
  return undefined;
};

// Multipart body for a QR requisite: null becomes an empty value (DRF reads it as null), undefined is not sent.
export const toFormData = (fields: Record<string, unknown>) => {
  const form = new FormData();
  Object.entries(fields).forEach(([name, value]) => {
    if (value === undefined) {
      return;
    }
    if (value instanceof Blob) {
      form.append(name, value);
      return;
    }
    form.append(name, value === null ? '' : String(value));
  });
  return form;
};

// Backend reasons for a rejected QR image: {"qr_image": [...]} or {"detail": "..."}.
export const qrImageErrorMessages = (data: unknown): string[] => {
  const { qr_image: qrImage, detail } = (data ?? {}) as { qr_image?: unknown; detail?: unknown };
  const messages = qrImage ?? detail;
  if (!messages) {
    return [];
  }
  return (Array.isArray(messages) ? messages : [messages]).map(String);
};
